import { render, staticRenderFns } from "./base-img.vue?vue&type=template&id=0e82c43b&scoped=true&"
import script from "./base-img.vue?vue&type=script&lang=js&"
export * from "./base-img.vue?vue&type=script&lang=js&"
import style0 from "./base-img.vue?vue&type=style&index=0&id=0e82c43b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e82c43b",
  null
  
)

export default component.exports